module.exports = __webpack_public_path__ + "img/8.8aa07ebc.jpg";